<template>
  <div class="bottom-div" style="">
    <div
      class="main-chart"
      style="display: flex; flex-direction: row-reverse; float: right; max-width: 600px;"
    >
      <div class="menu-wrapper">
        <ul class="sub-menu-dropup">
          <li
            v-for="tab in [
              { id: 1, alias: 'Methods' },
              { id: 2, alias: 'Projects' },
              { id: 3, alias: 'Category' },
              { id: 4, alias: 'Deducted' }
            ]"
            :key="tab.id"
            :class="{
              active: selectedTab === tab.alias
            }"
            class="dropdown-item btn btn-block btn-light-gray"
            style="padding: 0; font-size: 11px; font-weight: 500;"
            @click="setClickFromMenu(tab.alias)"
          >
            <span>
              <i class="fas fa-caret-left"></i>
            </span>
            <span class="tabName"> {{ tab.alias }}</span>
          </li>
        </ul>
      </div>
      <canvas id="finance-stats-main-chart"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import apiClientCreator from "../../../../helpers/api/request";
import ChartDataLabels from "chartjs-plugin-datalabels";

const retChartData = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          // return value === 0 ? value : value;
          return value;
        }
      }
    },
    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      mode: "index",
      intersect: false
    }
  }
};

export default {
  name: "ContactsGraph",
  props: {
    queryObject: {
      type: Object
    },
    rangePaymentMethodData: {
      type: Array
    }
  },
  data() {
    return {
      retChartData: retChartData,
      selectedTab: "Methods",
      loading: false
    };
  },
  mounted() {
    this.fetchStats();
  },

  watch: {
    queryObject: function() {
      this.fetchStats();
    },
    rangePaymentMethodData: function() {
      // this.createChart();
      // if (this.rangePaymentMethodData.length > 0) {
      //
      // }
    },
    selectedTab: function() {
      if (this.selectedTab === "Methods") {
        this.fetchStats("methods");
      }
      if (this.selectedTab === "Deducted") {
        this.fetchStats("deducted");
      }
      if (this.selectedTab === "Category") {
        this.fetchStats("category");
      }
      if (this.selectedTab === "Projects") {
        this.fetchStats("projects");
      }
    }
  },
  methods: {
    setClickFromMenu(tab) {
      this.selectedTab = tab;
    },

    rangeChartMethod(res){
      this.rangePaymentMethodData = res.data
      this.$emit('ALLData', {all:res.data})
      this.createChart();
    },

    fetchStats(tab = "methods") {
      apiClientCreator(`finance/stats/graph/${tab}`)
        .get("", { params: this.queryObject })
        .then(res => {
          this.rangeChartMethod(res)
          // this.rangePaymentMethodData = res.data,
          //     this.$emit('ALLData', {all:res.data})
          // let t = 0;
          // for (let i = 0; i < res.data.length; i++) {
          //   t = t += parseInt(res.data[i].count);
          // }
          // this.rangePaymentMethodData.push({ count: t, method: "SUM" });
        });
    },
    createChart() {
      let labels = [];
      let Count = [];
      let chartData = this.retChartData;
      let opt = chartData.options;
      let chartId = "finance-stats-main-chart";
      this.rangePaymentMethodData.forEach(r => {
        if(r.method != 'T.Expenses'
          && r.method != 'T.Income'
          && r.method != 'T.Sum'
        ){
          labels.push(r.method);
          Count.push(r.count);
        }
      });
      if (this.retChartBar) {
        this.retChartBar.destroy();
      }

      const data = {
        labels: labels,

        datasets: [
          {
            type: "bar",
            label: this.selectedTab === "Methods" ? "Spent" : "Deducted",
            data: Count,
            fill: true,
            borderColor: "black",
            backgroundColor: "rgba(255,0,0,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            hidden: false
          }
        ]
      };

      const ctx = document.getElementById(chartId);

      this.retChartBar = new Chart(ctx, {
        type: chartData.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    }
  }
};
</script>

<style scoped>
.bottom-div {
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
  width: calc(44%);
}

.main-chart {
  width: 100%;
  height: 200px;
  margin: 5px;
}

.menu-wrapper {
  float: right;
  position: relative;
  top: 5px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

li.active {
  background-color: #c12fff;
  color: #fff;
}

span.tabName {
  padding-left: 10px;
}
</style>
